"use client";

import Image from "next/image";
import { useRef } from "react";

import { devSectionAttr } from "@/lib/dev/section-attr";
import { useCcScrollSpeedParallax } from "@/lib/use-cc-scroll-speed-parallax";

/** Nuxt `FloatingImageSection.vue` floating image `data-speed`. */
const FLOATING_IMAGE_SCROLL_SPEED = 1.2;

type ShowcaseImage = {
  src: string;
  alt: string;
};

type CcWebDesignShowcaseProps = {
  main: ShowcaseImage;
  floating: ShowcaseImage;
};

export function CcWebDesignShowcase({ main, floating }: CcWebDesignShowcaseProps) {
  const stageRef = useRef<HTMLDivElement>(null);
  const floatingWrapRef = useRef<HTMLDivElement>(null);

  useCcScrollSpeedParallax(floatingWrapRef, {
    speed: FLOATING_IMAGE_SCROLL_SPEED,
    triggerRef: stageRef,
  });

  return (
    <figure
      className="cc-web-design-showcase"
      {...devSectionAttr("web-design-showcase")}
    >
      <div ref={stageRef} className="cc-web-design-showcase__stage">
        <Image
          src={main.src}
          alt={main.alt}
          width={960}
          height={720}
          sizes="(min-width: 810px) 52vw, 100vw"
          className="cc-web-design-showcase__main-img"
          priority
        />
        <div ref={floatingWrapRef} className="cc-web-design-showcase__floating-wrap">
          <Image
            src={floating.src}
            alt={floating.alt}
            width={720}
            height={480}
            sizes="(min-width: 810px) 44vw, 88vw"
            className="cc-web-design-showcase__floating-img"
          />
        </div>
      </div>
    </figure>
  );
}
